// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fed44e0d","453":"f4b82c36","455":"b5ae4969","977":"802511e9"}[chunkId] + ".chunk.js";
};